module.exports = __webpack_public_path__ + "static/media/trash-remove.77baa979.svg";